import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { EditPage, EditPagePanel, EditPageTextField, EditPageSelect, EditPageCheckbox } from './../../../../common/EditPage';
import { useState, useEffect } from 'react';
import { getOne, create } from './../../../../common/v4/BackendProvider';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
const CarrierSmppAccountsCreateClient = () => {

    const [data, setData] = useState({});
    const [metadata, setMetadata] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const { carrier_id } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        getOne(`/admin/carriers/carriers/${carrier_id}/client_smppaccounts/`, `new`).then(response => {
            setMetadata(response.data.metadata);
        });
    }, []);

    const handleSave = () => {
        create(`/admin/carriers/carriers/${carrier_id}/client_smppaccounts`, {data: data}).then(response => {
            toast.success("Carrier created successfully", {});
            navigate(`/carriers/carriers/${carrier_id}/smppaccounts`);
        }).catch(error => {
            toast.error("Error creating carrier: " + error.message, {});
        });
    }

    const handleCancel = () => {
        navigate(`/carriers/carriers/${carrier_id}/smppaccounts`);
    }

    const onChange = (id, value) => {
        setData({...data, [id]: value});
    };

    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick={true}
                pauseOnHover={true}
                draggable={true}
                progress="undefined"
            />
            <EditPage handleSave={ handleSave } handleCancel={ handleCancel } >
                <EditPagePanel>
                    <EditPageSelect label="Rate Profile" id="product_id" onChange={ onChange } value={ data.product_id } options={ metadata?.products } />
                    <EditPageTextField label="Username" id="username" onChange={ onChange } value={ data.username } />
                    <EditPageTextField label="Password" id="password" onChange={ onChange } value={ data.password } />
                    <EditPageSelect label="Bind Mode" id="bind_mode" onChange={ onChange } value={ data.bind_mode } options={ metadata?.bindModes } />
                    <EditPageSelect label="Coding" id="coding" onChange={ onChange } value={ data.coding } options={ metadata?.codings } />
                    <EditPageCheckbox label="Use SSL" id="use_ssl" onChange={ onChange } value={ data.use_ssl } />
                    <EditPageCheckbox label="Enabled" id="status" onChange={ onChange } value={ data.status } />
                </EditPagePanel>
            </EditPage>
        </>
    )
}


export default CarrierSmppAccountsCreateClient;